import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import {normalize, truthyWinsMergeStrategy} from '../../../util/utils';
import _ from 'lodash';

export function aresMyRiskFactorDescriptionReducer(state = initialstate.aresMyRiskFactorDescriptions, action) {
	switch (action.type) {
		case types.GET_FORM_BODIES_BY_SECTIONID:
			return applyFormBodyRiskFactors(state, action.response);
		case types.GET_RISKS_FACTORS:
			return applyDescriptions(state, action.response, false);
		case types.RELATE_RISK_FACTOR_TO_DESCRIPTION:
			return associateRiskFactor(state, action.riskFactorId, action.description, action.oldDescription);
		case types.UNRELATE_RISK_FACTOR_FROM_DESCRIPTION:
			return unAssociateRiskFactor(state, action.riskFactorId, action.description);
		case types.EDIT_RISK_FACTOR_DESCRIPTION:
			return editRiskFactorDescription(state, action.riskFactorId, action.description, action.oldDescription);
		//This actions are triggered by RiskFactor
		case types.CREATE_RISK_FACTOR_RELATION:
			return createRiskFactorRelation(state, action.riskFactorId, action.response.id, action.response.customDescription);
		case types.UPDATE_RISK_FACTOR_RELATION_DESCRIPTION:
			return updateRiskFactorRelation(state, action.riskFactorId, action.response.id, action.response.customDescription);
		case types.REMOVE_RISK_FACTOR_RELATION:
			return removeRiskFactorRelation(state, action.riskFactorId);
		default:
			return state;
	}
}

function applyFormBodyRiskFactors(state, formBodies) {
	let riskFactors = [];
	for (let i = 0; i < formBodies.length; i++) {
		let optionsAndResponses = formBodies[i].optionsAndResponses;

		if (optionsAndResponses?.length > 0) {
			for (let j = 0; j < optionsAndResponses.length; j++) {
				let riskFactorList = optionsAndResponses[j].riskFactorList;

				if (riskFactorList?.length > 0) {
					for (let k = 0; k < riskFactorList.length; k++) {
						let riskFactor = mapRiskFactor(riskFactorList[k]);

						if (riskFactors.indexOf(riskFactor.id) === -1) {
							riskFactors.push(riskFactor);
						}
					}
				}
			}
		}
	}

	return applyDescriptions(state, riskFactors);
}

function applyDescriptions(state, response, preserveRiskFactorDescriptions = true) {
	const currentState = _.cloneDeep(state);

	let normalized = {
		riskFactors: {
			byId: {},
			allIds: []
		},
		descriptions: preserveRiskFactorDescriptions ? {
			...currentState.descriptions
		} : {

			byId: {},
			allIds: []
		}
	};

	let mappedRFlist = response && response.length > 0 && response.map((x) => mapRiskFactor(x));

	if (mappedRFlist?.length > 0) {
		normalized.riskFactors = normalize(mappedRFlist, undefined, state.riskFactors, truthyWinsMergeStrategy);
		for (let i = 0; i < mappedRFlist.length; i++) {
			if (descriptionIsValid(mappedRFlist[i].customDescription)) {
				if (!descriptionIsRepeated(normalized.descriptions.allIds, mappedRFlist[i].customDescription)) {
					normalized.descriptions.allIds.push(mappedRFlist[i].customDescription);
					normalized.descriptions.byId[mappedRFlist[i].customDescription] = [];
				}
				if (!descriptionIsRepeated(normalized.descriptions.byId[mappedRFlist[i].customDescription], mappedRFlist[i].id))
					normalized.descriptions.byId[mappedRFlist[i].customDescription].push(mappedRFlist[i].id);
			}
		}
	}

	normalized.descriptions.allIds = sortDescriptions(normalized.descriptions.allIds)

	return normalized;
}

function associateRiskFactor(slice, riskFactorId, description, oldDescription) {
	//We push the riskFactorId.
	slice = unAssociateRiskFactor(slice, riskFactorId, oldDescription);
	if (slice.descriptions.byId[description]) {
		slice = {
			...slice,
			descriptions: {
				...slice.descriptions,
				byId: {
					...slice.descriptions.byId,
					[description]: [...slice.descriptions.byId[description], riskFactorId]
				}
			}
		};
	} else {
		//We add a new entry for the description with the riskFactorId.
		slice = {
			...slice,
			descriptions: {
				...slice.descriptions,
				byId: {
					...slice.descriptions.byId,
					[description]: [riskFactorId]
				},
				allIds: sortDescriptions([...slice.descriptions.allIds, description])
			}
		};
	}

	return slice;
}

function unAssociateRiskFactor(state, riskFactorId, description) {
	let _description = description;

	if (_description) {
		state = {
			...state,
			descriptions: {
				...state.descriptions,
				byId: {
					...state.descriptions.byId,
					[_description]: state.descriptions.byId[_description]?.filter((id) => id !== riskFactorId)
				}
			}
		};

		if (!descriptionIsUsed(state, _description)) {
			state = {
				...state,
				descriptions: {
					...state.descriptions,
					byId: {
						...state.descriptions.byId,
						[_description]: undefined
					},
					allIds: state.descriptions.allIds.filter((desc) => desc !== _description)
				}
			};
		}
	}

	return state;
}

function editRiskFactorDescription(state, riskFactorId, newDescription, oldDescription) {
	if (oldDescription && oldDescription !== newDescription) {
		state = {
			...state,
			descriptions: {
				...state.descriptions,
				byId: {
					...state.descriptions.byId,
					[newDescription]: [...state.descriptions.byId[oldDescription]],
					[oldDescription]: undefined
				},
				allIds: sortDescriptions([
					...state.descriptions.allIds.filter((desc) => desc !== oldDescription),
					newDescription
				])
			}
		};
	}

	return state;
}

function createRiskFactorRelation(state, riskFactorID, riskFactorRelationId, customDescription) {
	return setRiskFactorRelation(state, riskFactorID, riskFactorRelationId, customDescription);
}

function updateRiskFactorRelation(state, riskFactorID, riskFactorRelationId, customDescription) {
	return setRiskFactorRelation(state, riskFactorID, riskFactorRelationId, customDescription);
}

function removeRiskFactorRelation(state, riskFactorID) {
	return setRiskFactorRelation(state, riskFactorID, undefined);
}

function setRiskFactorRelation(state, riskFactorID, value, customDescription) {
	return {
		...state,
		riskFactors: {
			...state.riskFactors,
			byId: {
				...state.riskFactors.byId,
				[riskFactorID]: {
					...state.riskFactors.byId[riskFactorID],
					riskFactorRelationId: value,
					customDescription: customDescription
				}
			}
		}
	};
}

function mapRiskFactor(riskFactor) {
	return {
		...riskFactor,
		id: riskFactor.riskFactorID || riskFactor.id
	};
}

function descriptionIsValid(newDescription) {
	return newDescription !== '' && newDescription !== null;
}

function descriptionIsRepeated(descriptions, description) {
	return descriptions.indexOf(description) !== -1;
}

function descriptionIsUsed(slice, description) {
	return slice.descriptions.byId[description]?.length > 0;
}

function sortDescriptions(descriptions) {
	return descriptions.sort((a, b) => {
		if (a > b) return 1;
		if (a < b) return -1;
	});
}
